<template>
  <div>
      <h2 style="text-align: center; margin-bottom: 20px;">公司信息管理</h2>
      
      <el-form :model="form" label-width="120px" size="medium">
        <!-- 新增：与新闻表单一致的图片上传组件 -->
        

        <!-- 原有公司信息字段保持不变 -->
        <el-form-item label="公司名称">
          <el-input v-model="form.name" />
        </el-form-item>
        
        <el-form-item label="地址">
          <el-input v-model="form.address" />
        </el-form-item>

        <el-form-item label="电话">
          <el-input v-model="form.phone" />
        </el-form-item>

        <el-form-item label="邮箱">
          <el-input v-model="form.email" />
        </el-form-item>

        <el-form-item label="口号">
          <el-input v-model="form.slogan" />
        </el-form-item>

        <el-form-item label="关于我们">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="form.about_us" />
        </el-form-item>

        <el-form-item label="公司简介">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 12 }" v-model="form.company_intro" />
        </el-form-item>

        <el-form-item label="愿景">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.vision" />
        </el-form-item>

        <el-form-item label="使命">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.mission" />
        </el-form-item>

        <el-form-item label="核心价值观">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.core_values" />
        </el-form-item>

        <el-form-item label="企业精神">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.spirit" />
        </el-form-item>

        <el-form-item label="企业宗旨">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.purpose" />
        </el-form-item>

        <el-form-item label="战略">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.strategy" />
        </el-form-item>
        <el-form-item label="公司图片">
          <!-- 原生文件选择框，与新闻表单保持一致 -->
          <input type="file" ref="fileInput" @change="onFileChange" accept="image/jpeg,image/png,image/jpg" />
          <!-- 图片预览区域，无图时不显示 -->
          <div v-if="form.imagePreview" style="margin-top: 10px;">
            <el-image 
              :src="form.imagePreview" 
              style="width: 120px; height: 120px;" 
              fit="cover" 
              preview-teleported
            />
            <!-- 新增：删除图片按钮，增强交互 -->
            <el-button 
              type="text" 
              style="color: #f56c6c; margin-left: 10px;"
              @click="handleDeleteImage"
            >
              删除图片
            </el-button>
          </div>
          <!-- 提示文本：显示当前已存储的图片URL（可选，方便用户确认） -->
          <div v-if="form.company_image && !form.imagePreview" style="margin-top: 10px; color: #606266; font-size: 12px;">
            当前图片：{{ form.company_image.slice(0, 50) }}...
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import { getCompanyInfo, updateCompanyInfo } from "@/api/company";
import { Message } from "element-ui";

export default {
  name: "CompanyInfo",
  data() {
    return {
      form: {
        id: null,
        name: "",
        address: "",
        phone: "",
        email: "",
        slogan: "",
        about_us: "",
        company_intro: "",
        company_image: "", // 存储后端返回的图片URL（字符串）
        image: null,       // 存储选择的文件对象（用于上传），与新闻表单一致
        imagePreview: null,// 存储图片预览URL，与新闻表单一致
        awards: { 奖项: "" },
        research: { 研究: "" },
        scenarios: { 场景: "" },
        vision: "",
        mission: "",
        core_values: "",
        spirit: "",
        purpose: "",
        strategy: ""
      }
    };
  },
  created() {
    this.loadCompany();
  },
  methods: {
    async loadCompany() {
      try {
        const res = await getCompanyInfo();
        if (res.status === 200 && res.data) {
          const companyData = res.data.data;
          this.form = { 
            ...companyData,
            // 初始化：若有已存图片URL，生成预览（与新闻表单edit逻辑一致）
            image: null,
            imagePreview: companyData.company_image ? this.getFullImageUrl(companyData.company_image) : null
          };
        } else {
          Message.error(res.msg || "获取公司信息失败");
        }
      } catch (err) {
        Message.error("请求异常");
      }
    },
    // 核心修改：与新闻表单一致的FormData提交逻辑
    async save() {
      try {
        // 1. 构建FormData（与新闻表单save方法逻辑完全一致）
        const formData = new FormData();
        Object.keys(this.form).forEach((key) => {
          // 排除预览URL，其他有效字段都加入FormData
          if (this.form[key] !== undefined && this.form[key] !== null && key !== "imagePreview") {
            // 特殊处理JSON字段（如awards/research）：转为字符串（避免FormData直接传对象）
            if (typeof this.form[key] === "object" && !this.form[key] instanceof File) {
              formData.append(key, JSON.stringify(this.form[key]));
            } else {
              formData.append(key, this.form[key]);
            }
          }
        });

        // 2. 调用更新接口（公司信息通常是单条，用update接口）
        const res = await updateCompanyInfo(formData);
        
        if (res.status === 200) {
          Message.success("公司信息保存成功");
          // 保存后重新加载数据，更新预览状态
          this.loadCompany();
          // 重置文件选择框（与新闻表单resetForm逻辑一致）
          if (this.$refs.fileInput) {
            this.$refs.fileInput.value = "";
          }
        } else {
          Message.error(res.msg || "保存失败");
        }
      } catch (err) {
        Message.error("请求异常");
        console.error("保存错误：", err);
      }
    },
    // 与新闻表单完全一致的文件选择事件
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 校验文件类型（可选，增强容错）
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        Message.error("请选择JPG或PNG格式的图片");
        this.$refs.fileInput.value = ""; // 重置选择
        return;
      }

      // 存储文件对象 + 生成预览URL（与新闻表单逻辑一致）
      this.form.image = file;
      this.form.imagePreview = URL.createObjectURL(file);
    },
    // 与新闻表单一致的图片URL拼接方法（若后端返回相对路径，需拼接服务器地址）
    getFullImageUrl(imagePath) {
      // 这里复用新闻表单的服务器地址逻辑，确保图片预览地址正确
      return this.$serverUrl ? this.$serverUrl + imagePath : imagePath;
    },
    // 新增：删除图片（重置文件和预览）
    handleDeleteImage() {
      this.form.image = null;
      this.form.imagePreview = null;
      this.form.company_image = ""; // 同时清空已存的图片URL
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
      Message.success("图片已删除");
    }
  },
  // 组件销毁时释放预览URL（避免内存泄漏，优化性能）
  beforeDestroy() {
    if (this.form.imagePreview) {
      URL.revokeObjectURL(this.form.imagePreview);
    }
  }
};
</script>

<style scoped>
.el-card {
  max-width: 900px;
  margin: 20px auto;
}

/* 优化文件选择框样式（与新闻表单视觉统一） */
input[type="file"] {
  padding: 4px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

/* 预览图片区域样式微调 */
.el-image {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
</style>